<script setup>
const user = useState('user');

const openFeedbackModal = useState('openFeedbackModal');

const isMapToolOpen = useState('isMapToolOpen', () => false);

// We want to hide the footer on some pages
const currentRoute = useRoute();
const routeFoldersWithoutFooter = ['/zoning-editor', '/content', '/auth'];
const showFooter = computed(() => {
  return !routeFoldersWithoutFooter.some(folder => currentRoute.path.includes(folder)) && !isMapToolOpen.value;
});
</script>

<template>
  <footer v-if="showFooter" class="bg-gray-100 w-full px-3 lg:px-8 py-6 hidden sm:block">
    <div class="flex justify-between text-sm mx-auto">
      <div>
        <!-- Siteability Logo -->
        <NuxtLink to="https://siteability.ca/">
          <NuxtImg src="/images/logo.png" alt="Logo" class="h-11" />
        </NuxtLink>
        <!-- Siteability 'S' For Small Screen logo -->

        <p v-if="user" class="text-gray-600 text-xs ml-2 mt-2 max-w-72">
          Always confirm details about your property with your municipality's planning department
          or a certified consultant.
        </p>
      </div>
      <div class="flex space-x-6 sm:space-x-20">
        <div v-if="user" class="flex flex-col items-start">
          <h3 class="font-bold text-gray-800 mb-2">Noticed a Problem?</h3>
          <button @click="openFeedbackModal.open()" class="underline text-gray-706 cursor-pointer">
            Share Feedback
          </button>
        </div>
        <div class="flex flex-col">
          <h3 class="font-bold text-gray-800 mb-2">Contact Us</h3>
          <NuxtLink to="https://www.linkedin.com/company/siteability/" target="_blank"
            class="underline text-gray-706 cursor-pointer mb-1">
            LinkedIn</NuxtLink>
          <NuxtLink href="mailto:founders@siteability.ca" class="underline text-gray-706 cursor-pointer">
            founders@siteability.ca
          </NuxtLink>
        </div>
      </div>
    </div>
  </footer>
  <footer v-if="showFooter" class="bg-[#1f2023] w-full px-3 lg:px-8 py-6 sm:hidden">
    <div class="text-sm mx-auto">
      <div class="flex justify-left mb-4">
        <!-- Siteability Logo -->
        <NuxtImg src="/images/logo.png" alt="Logo" class="h-11" />
      </div>
      <p v-if="user" class="text-gray-600 text-xs text-center mb-4">
        Always confirm details about your property with your municipality's planning department
        or a certified consultant.
      </p>
      <div class="grid grid-cols-2 gap-3">
        <div class="items-center ml-2">
          <h3 class="font-bold text-gray-800 mb-2">Noticed a Problem?</h3>
          <button @click="openFeedbackModal.open()" class="underline text-gray-706 cursor-pointer">
            Share Feedback
          </button>
        </div>
        <div class="items-center">
          <h3 class="font-bold text-gray-800 mb-2">Contact Us</h3>
          <NuxtLink to="https://www.linkedin.com/company/siteability/" target="_blank"
            class="underline text-gray-706 cursor-pointer mb-2">
            LinkedIn
          </NuxtLink>
          <NuxtLink href="mailto: founders@siteability.ca" class="underline text-gray-706 cursor-pointer">
            founders@siteability.ca
          </NuxtLink>
        </div>
      </div>
    </div>
  </footer>
</template>